export default __webpack_public_path__ + "locales/si/People.json?hash=abbdee91f1e9a27d44ffd5772bb56451";